import React from 'react'
import { Link } from 'react-router-dom'


function Card({ id, title, label, status, status_description, hashtag, image_url }) {
  return (
    <div className="wrapper" key={id}>
      <div className="card">
        <div className="card-banner">
          <p className="category-tag popular">{status}</p>
          <img className="banner-img" src={image_url} alt='' />
        </div>
        <div className="card-body">
          <p className="blog-hashtag">{hashtag}</p>
          <h2 className="blog-title">{title}</h2>
          <p className="blog-description limit__text">{status_description}</p>
        </div>
        <Link to={`/${label}/${id}`} className='about-btn card-btn'>Show Details</Link>
      </div>
    </div>  
  )
}

export default Card